<script lang="ts">
    import ChevronDownIcon from "svelte-material-icons/ChevronDown.svelte"
    import CloseIcon from "svelte-material-icons/Close.svelte"
    import { clickOutside } from "../../utils"

    export let options: {
        value: any
        label: string
    }[]

    export let value
    export let multiple = false

    if (typeof value === "undefined") {
        value = options[0] && options[0].value
    }

    let index

    let oldValue
    $: if (value !== oldValue) {
        options?.forEach((o, idx) => {
            if (o.value == value) {
                index = idx
            }
        })
        oldValue = value
    }

    let selectopen = false

    function clickValue(v) {
        if (!multiple) {
            value = v
            return
        }

        // multiple select
        if (Array.isArray(value)) {
            if (value.includes(v)) {
                // remove value from array
                value = value.filter((_v) => _v !== v)
                if (!value.length) {
                    value = null
                }
            } else {
                value = [...value, v]
            }
        } else {
            value = [v]
        }
    }
</script>

<div
    class="select"
    class:active="{selectopen}"
    use:clickOutside="{(target) => {
        selectopen = false
    }}"
>
    {#if options?.length}
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div class="trigger" on:click="{() => (selectopen = !selectopen)}">
            <div class="title">
                {#if multiple}
                    {#if value?.length}
                        {#each options || [] as option}
                            {#if value.includes(option.value)}
                                <span class="selectedOptionLabel"
                                    >{@html option.label}
                                    <button
                                        type="button"
                                        on:click|stopPropagation="{() => {
                                            clickValue(option.value)
                                        }}"><CloseIcon size="18px" /></button
                                    ></span
                                >
                            {/if}
                        {/each}
                    {/if}
                {:else}
                    {@html (options[index] && (options[index].label || " ")) || options[0].label}
                {/if}
            </div>
            <div class="icon">
                <ChevronDownIcon size="24px" />
            </div>
        </div>
        <div class="list">
            {#each options || [] as option}
                <!-- svelte-ignore a11y-click-events-have-key-events -->
                <div
                    class="option"
                    on:click="{() => {
                        clickValue(option.value)
                        if (!multiple) {
                            selectopen = false
                        }
                    }}"
                    class:selected="{multiple && value?.length && value.includes(option.value)}"
                >
                    {@html option.label}
                </div>
            {/each}
        </div>
    {/if}
</div>

<style lang="less">
    @import "../../css/variables.less";
    .select {
        position: relative;
        width: 100%;
        max-width: 100%;
        @media (max-width: 768px) {
            width: 100%;
        }

        .trigger {
            .flex();
            justify-content: space-between;
            align-items: center;
            cursor: pointer;
            .icon {
                .flex();
                align-items: center;
                justify-content: center;
            }
            border-bottom: solid 1px var(--primary);
        }
        .list {
            position: absolute;
            top: 150%;
            left: 0;
            background-color: var(--comp--select--background);
            color: var(--comp--select--color);
            border: solid 1px var(--border-color-default);
            padding: 15px;
            width: 100%;
            z-index: 2000;
            .transition();
            .opacity(0);
            visibility: hidden;

            .option {
                border-bottom: solid 1px var(--border-color-default);
                padding: 5px;
                cursor: pointer;
                &:last-child {
                    border: 0;
                }
                &:hover {
                    background-color: var(--comp--select--background-hover);
                }
            }
        }
        &.active .list {
            top: 130%;
            .opacity(1);
            visibility: visible;
        }

        .option.selected {
            background-color: var(--surface-4);
        }

        .selectedOptionLabel {
            display: inline-block;
            border-radius: 30px;
            background: var(--surface-4);
            color: var(--on-surface-4);
            margin-right: 10px;
            margin-bottom: 5px;
            padding: 6px 15px;
            line-height: 1;
            font-size: 0.8rem;
            button {
                border: none;
                outline: none;
                cursor: pointer;
                background: none;

                &:hover {
                    color: var(--primary);
                }
                &:active {
                    border: none;
                    outline: none;
                    background: none;
                }
            }
        }
    }
</style>
